// extracted by mini-css-extract-plugin
module.exports = {"taskPrompt":"CreateSprayTaskPrompt_taskPrompt__Fxzk0"};